var emojiRegex = /(\u00a9|\u00ae|\ud83c[\ud000-\udfff]|\ud83d[\ud000-\udfff]|\ud83e[\ud000-\udfff])/g;
export var stripEmojis = function stripEmojis(message) {
  return message.replace(emojiRegex, '');
};